export default function MapJapan() {
  return (
    <>
      <img
        src="/img/about-us/map-japan-2.png"
        alt="Japan Map Background"
        className="absolute right-0 top-0 h-auto w-auto object-contain"
      />
    </>
  )
}
